/** Browser-safe constants shared by the control plane and the client SDK. */
export const TOKEN_PRIVILEGE_WILL_EXPIRE_LEAD_SECONDS = 30;
//# sourceMappingURL=constants.js.map